import INIT from "../class/init";
// import pageTopObserver from "./pageTopObserver";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 989px)" ) ];

export default class CUSTOMIZE extends INIT {

  constructor() {
    super();
    this.customInit();
    this.menuOpen();
    this.footBtn();
  }

  customInit() {
    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );
    
    // const pagetop = d.querySelector('.footer-pagetop__wrap');
    // new pageTopObserver(pagetop);

    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    $(() => this.hashscroll() );
  }

  menuOpen() {
    $('#menu_slideTrigger').on('click', function(){
      $(this).toggleClass('open');
    });
  }
  footBtn() {
    $('.footerLegal__title button').on('click', function(){
      $(this).find('.icon').toggleClass('active');
    });
  }
}

window.WebFontConfig = {
  google: {
    families: ['Jost:500', 'Work+Sans:600', 'Mulish:500,600,700', 'Roboto:400,500,700']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();